import React, { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    service: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate form submission
    setTimeout(() => {
      setSubmitted(true);
      setIsSubmitting(false);
    }, 1500);
  };

  return (
    <>
      {/* Hero Section */}
      <section className="section" style={{ background: 'var(--gradient-primary)', color: 'white', paddingTop: '6rem', paddingBottom: '6rem' }}>
        <div className="container text-center">
          <h1 style={{ color: 'white', fontSize: '3rem', marginBottom: '1.5rem' }}>
            Get in <span style={{ color: 'var(--primary-green)' }}>Touch</span>
          </h1>
          <p style={{
            fontSize: '1.25rem',
            maxWidth: '600px',
            margin: '0 auto',
            color: 'rgba(255, 255, 255, 0.9)',
            lineHeight: 1.7
          }}>
            Ready to transform your business? Let's discuss how our SaaS solutions can help you achieve your goals.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="section">
        <div className="container">
          <div className="grid grid-2" style={{ gap: '4rem', alignItems: 'flex-start' }}>
            {/* Contact Form */}
            <div>
              <div className="card" style={{ padding: '3rem' }}>
                <h2 style={{ marginBottom: '2rem', color: 'var(--primary-blue)' }}>Send us a Message</h2>

                {submitted ? (
                  <div style={{ textAlign: 'center', padding: '3rem 0' }}>
                    <div style={{
                      fontSize: '4rem',
                      color: 'var(--success)',
                      marginBottom: '1rem'
                    }}>
                      ✓
                    </div>
                    <h3 style={{ color: 'var(--success)', marginBottom: '1rem' }}>
                      Thank You!
                    </h3>
                    <p style={{ color: 'var(--gray-600)', marginBottom: '2rem' }}>
                      Your message has been sent successfully. We'll get back to you within 24 hours.
                    </p>
                    <button
                      onClick={() => {
                        setSubmitted(false);
                        setFormData({
                          name: '', email: '', company: '', phone: '', service: '', message: ''
                        });
                      }}
                      className="btn btn-primary"
                    >
                      Send Another Message
                    </button>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      <label className="form-label">Full Name *</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        className="form-input"
                        placeholder="Enter your full name"
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">Email Address *</label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        className="form-input"
                        placeholder="Enter your email address"
                      />
                    </div>

                    <div className="grid grid-2" style={{ gap: '1rem' }}>
                      <div className="form-group">
                        <label className="form-label">Company</label>
                        <input
                          type="text"
                          name="company"
                          value={formData.company}
                          onChange={handleInputChange}
                          className="form-input"
                          placeholder="Your company name"
                        />
                      </div>

                      <div className="form-group">
                        <label className="form-label">Phone Number</label>
                        <input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          className="form-input"
                          placeholder="Your phone number"
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="form-label">Service Interest</label>
                      <select
                        name="service"
                        value={formData.service}
                        onChange={handleInputChange}
                        className="form-input"
                        style={{ cursor: 'pointer' }}
                      >
                        <option value="">Select a service...</option>
                        <option value="crm">CRM Suite</option>
                        <option value="inventory">Inventory Management</option>
                        <option value="hr-payroll">HR & Payroll</option>
                        <option value="accounting">Accounting & Invoicing</option>
                        <option value="custom">Custom Development</option>
                        <option value="consultation">General Consultation</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label className="form-label">Message *</label>
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        required
                        rows={5}
                        className="form-textarea"
                        placeholder="Tell us about your project or requirements..."
                      ></textarea>
                    </div>

                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={isSubmitting}
                      style={{
                        width: '100%',
                        opacity: isSubmitting ? 0.7 : 1,
                        cursor: isSubmitting ? 'not-allowed' : 'pointer'
                      }}
                    >
                      {isSubmitting ? 'Sending Message...' : 'Send Message'}
                    </button>
                  </form>
                )}
              </div>
            </div>

            {/* Contact Information */}
            <div>
              <div style={{ marginBottom: '3rem' }}>
                <h2 style={{ marginBottom: '2rem', color: 'var(--primary-blue)' }}>Contact Information</h2>
                <p style={{ color: 'var(--gray-600)', marginBottom: '2rem', lineHeight: 1.7 }}>
                  We're here to help you succeed. Reach out to us through any of the channels below,
                  and our team will respond promptly to assist with your needs.
                </p>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                {contactInfo.map((info, index) => (
                  <div key={index} className="card" style={{
                    padding: '2rem',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '1.5rem',
                    background: 'var(--gray-50)',
                    border: 'none'
                  }}>
                    <div style={{
                      fontSize: '2rem',
                      background: 'var(--gradient-accent)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text',
                      flexShrink: 0
                    }}>
                      {info.icon}
                    </div>
                    <div>
                      <h3 style={{ marginBottom: '0.5rem', color: 'var(--gray-800)' }}>{info.title}</h3>
                      <p style={{ color: 'var(--gray-600)', margin: 0 }}>{info.details}</p>
                      {info.note && (
                        <p style={{ color: 'var(--accent-cyan)', fontSize: '0.9rem', margin: '0.5rem 0 0 0' }}>
                          {info.note}
                        </p>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Quick Action Buttons */}
              <div style={{ marginTop: '3rem' }}>
                <h3 style={{ marginBottom: '1.5rem', color: 'var(--gray-800)' }}>Quick Actions</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                  <a
                    href="mailto:contact@vissdatech.com"
                    className="btn btn-outline"
                    style={{ textDecoration: 'none', textAlign: 'center' }}
                  >
                    📧 Send Email
                  </a>
                  <a
                    href="tel:+15551234567"
                    className="btn btn-outline"
                    style={{ textDecoration: 'none', textAlign: 'center' }}
                  >
                    📞 Call Now
                  </a>
                  <button
                    className="btn btn-accent"
                    onClick={() => {
                      // Scroll to form
                      document.querySelector('form').scrollIntoView({ behavior: 'smooth' });
                    }}
                  >
                    💬 Schedule Demo
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="section" style={{ background: 'var(--gray-50)' }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: '4rem' }}>
            <h2>Frequently Asked Questions</h2>
            <p style={{ fontSize: '1.125rem', maxWidth: '600px', margin: '0 auto', color: 'var(--gray-600)' }}>
              Quick answers to common questions about our services and process
            </p>
          </div>

          <div className="grid grid-2" style={{ gap: '2rem' }}>
            {faqs.map((faq, index) => (
              <div key={index} className="card">
                <h4 style={{ color: 'var(--primary-blue)', marginBottom: '1rem' }}>{faq.question}</h4>
                <p style={{ color: 'var(--gray-600)', lineHeight: 1.6 }}>{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section" style={{ background: 'var(--gradient-hero)', color: 'white' }}>
        <div className="container text-center">
          <h2 style={{ color: 'white', fontSize: '2.5rem', marginBottom: '1rem' }}>
            Ready to Get Started?
          </h2>
          <p style={{
            fontSize: '1.25rem',
            marginBottom: '2rem',
            color: 'rgba(255, 255, 255, 0.9)',
            maxWidth: '600px',
            margin: '0 auto 2rem auto'
          }}>
            Don't wait to transform your business. Our team is ready to help you succeed with the perfect SaaS solution.
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              onClick={() => {
                document.querySelector('form').scrollIntoView({ behavior: 'smooth' });
              }}
              className="btn btn-accent"
            >
              Start Your Project
            </button>
            <a
              href="tel:+995595051875"
              className="btn btn-outline"
              style={{ color: 'white', borderColor: 'white', textDecoration: 'none' }}
            >
              Call Us Now
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

const contactInfo = [
  {
    icon: "📍",
    title: "Our Location",
    details: "30 N Gould St Ste N, Sheridan, SHERIDAN COUNTY, WY 82801 USA",
    note: "Corporate Headquarters"
  },
  {
    icon: "📞",
    title: "Phone Support",
    details: "+995 595051875",
    note: "Available 24/7 for urgent matters"
  },
  {
    icon: "📧",
    title: "Email Contact",
    details: "info@vissdatech.com",
    note: "We respond within 24 hours"
  },
  {
    icon: "⏰",
    title: "Business Hours",
    details: "Monday - Friday: 8:00 AM - 6:00 PM (MST)",
    note: "Emergency support available 24/7"
  }
];

const faqs = [
  {
    question: "How long does implementation typically take?",
    answer: "Implementation timelines vary based on complexity, but most standard solutions are deployed within 2-4 weeks. Custom solutions may take 6-12 weeks depending on requirements."
  },
  {
    question: "Do you provide training for our team?",
    answer: "Yes! We include comprehensive training for all users as part of our implementation process. We also provide ongoing training materials and support."
  },
  {
    question: "What kind of support do you offer?",
    answer: "We offer 24/7 technical support, dedicated customer success managers, and comprehensive documentation. Emergency support is available for critical issues."
  },
  {
    question: "Can you integrate with our existing systems?",
    answer: "Absolutely! Our solutions are designed to integrate seamlessly with popular business tools and databases. We also provide custom integration services."
  },
  {
    question: "What security measures do you have in place?",
    answer: "We implement enterprise-grade security including SOC 2 compliance, end-to-end encryption, regular security audits, and GDPR compliance."
  },
  {
    question: "Do you offer custom development?",
    answer: "Yes, we specialize in custom SaaS development tailored to your specific business needs. Our team can build completely bespoke solutions from scratch."
  }
];

export default Contact;